import { render } from "./KDSPage.vue?vue&type=template&id=7876dc56&scoped=true"
import script from "./KDSPage.vue?vue&type=script&lang=js"
export * from "./KDSPage.vue?vue&type=script&lang=js"

import "./KDSPage.vue?vue&type=style&index=0&id=7876dc56&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7876dc56"]])

export default __exports__